import CourseSkillListContainer from '@src/components/course/skillList/CourseSkillListContainer';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

const CourseSkillListPage = (props: WithRouterProps) => <CourseSkillListContainer courseId={props.params.courseId} />;

export default withRouter(CourseSkillListPage);
